import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import StarIcon from "@mui/icons-material/Star";
import { Card, Typography, Grid, useMediaQuery,useTheme } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PdfIcon from "../../Candidates/pdficon"; // Import your PDF icon component
import WordIcon from "../../Candidates/wordicon";
// import ImageIcon from "./Imgicon";
import { getCandidateDocuments, uploadDocumentsAction, } from "../../redux/action";
import { appSelector } from "../../redux/selector";
import { useDispatch, useSelector } from "react-redux";
import url from "../../../api/apisList";
import { userSelector } from "../../user-redux/selector";
import Key from "../../../clientVariables.json";
import { myCandidatesSelector } from "../redux/selector";
import { Worker, Viewer } from '@react-pdf-viewer/core';





function DocumentsView() {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedMenuItem, setSelectedMenuItem] = useState("");
    const { candidateDocuments, selectedCandidate } = useSelector(appSelector);
    const { candidateDetails } = useSelector(myCandidatesSelector);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Mobile devices
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // Tablets
    const isDesktopSmall = useMediaQuery(theme.breakpoints.between('md', 'lg')); // Small desktops
    const isDesktopLarge = useMediaQuery(theme.breakpoints.up('lg'));






    const { user } = useSelector(userSelector);
    const dispatch = useDispatch();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        console.log('selected Candidate', candidateDetails?.candidate_id)
        if (candidateDetails?.candidate_id) {
            dispatch(
                getCandidateDocuments(
                    candidateDetails?.candidate_id,
                    candidateDetails?.user_id
                )
            );
        }
    }, [candidateDetails]);

    useEffect(() => {
        setSelectedFiles([]);
        if (candidateDocuments?.length > 0) {
            //setSelectedFiles(candidateDocuments);
            const enhancedDocs = candidateDocuments.map((doc) => {
                const type = getFileType(doc.name);
                const isImage = type === "image";
                const thumbnail = isImage
                    ? url("candidate_attachment_file")(doc.user_id, doc.cand_id, doc.name)
                    : null;

                return { ...doc, type, thumbnail };
            });

            setSelectedFiles(enhancedDocs);

        }
    }, [candidateDocuments]);
    const handleMenuItemClick = (item) => {
        // Allow only PDF or image files for all menu items
        if (
            ["Visa copy", "Driving Licence", "i-9", "i-797", "E-Verify", "Certification"].includes(
                item
            )
        ) {
            fileInputRef.current.accept = ".pdf, .jpg, .jpeg, .png";
        } else {
            // Reset accept attribute for other menu items
            fileInputRef.current.accept = "";
        }

        fileInputRef.current.click();
        handleClose();
        setSelectedMenuItem(item);
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        const filedata = new FormData();
        filedata.append("file", file);
        filedata.append("userid", candidateDetails?.user_id);
        filedata.append("candidateid", candidateDetails?.candidate_id);
        filedata.append("filename", file?.name);
        filedata.append("file_size", file?.size);
        filedata.append("file_type", file?.type);
        filedata.append("attachment_type", "Candidate_attachment");
        filedata.append("attachment_name", selectedMenuItem);
        filedata.append("file_created", file?.lastModifiedDate);
        try {
            await fetch(`${Key.domain}/candidate/upload_document`, {
                method: "POST",
                body: filedata,
            });
            dispatch(
                getCandidateDocuments(
                    candidateDetails?.candidate_id,
                    candidateDetails?.user_id
                )
            );
        } catch (err) {
            console.error("Error uploading file:", err);
        }
        const newFiles = await Promise.all(
            Array.from(e.target.files).map(async (file) => {
                const type = getFileType(file.name);
                let thumbnail = "";

                if (type === "image") {
                    thumbnail = URL.createObjectURL(file); // generate preview
                }

                return {
                    file,
                    name: file.name,
                    type,
                    attachment_name: selectedMenuItem,
                    thumbnail,
                };
            })
        );

        const existingFilesWithSameType = selectedFiles.filter(
            (fileData) => fileData.type === selectedMenuItem
        );

        if (existingFilesWithSameType.length > 0) {
            const userConfirmed = window.confirm(
                "A file with the same type already exists. Do you want to replace it?"
            );

            if (!userConfirmed) {
                // User cancelled the replacement
                return;
            }
        }

        const updatedFiles = selectedFiles.filter(
            (fileData) => fileData.type !== selectedMenuItem
        );
        setSelectedFiles([...updatedFiles, ...newFiles]);

        // dispatch(uploadDocumentsAction(selectedMenuItem, newFiles));
        // Reset the accept attribute after files are selected

        fileInputRef.current.accept = "";
    };

    const getFileTypeIcon = (fileType, thumbnail) => {
        switch (fileType) {
            case "pdf":
                return <PdfIcon style={{ fontSize: "50px", color: "red" }} />;
            case "word":
                return <WordIcon style={{ fontSize: "50px", color: "blue" }} />;
            case "image":
                return (
                    <img
                        src={thumbnail}
                        alt="Thumbnail"
                        style={{ width: "50px", height: "50px", objectFit: "cover" }}
                    />
                );
            default:
                return <InsertDriveFileIcon />;
        }
    };

    const getFileType = (fileName) => {
        const extension = fileName?.split(".").pop().toLowerCase();
        if (["pdf"].includes(extension)) {
            return "pdf";
        } else if (["doc", "docx"].includes(extension)) {
            return "word";
        } else if (["jpg", "jpeg", "png", "gif"].includes(extension)) {
            return "image";
        } else {
            return "other";
        }
    };

    const menuItems = [
        "Visa copy",
        "Driving Licence",
        "i-9",
        "i-797",
        "E-Verify",
        "Certification"
    ];

    const fileInputRef = React.useRef(null);

    const openFileInNewTab = (fileData) => {
        let apiUrl = url("candidate_attachment_file")(
            fileData?.user_id,
            fileData?.cand_id,
            fileData?.name
        );

        // const fileUrl = URL.createObjectURL(fileData.file);
        window.open(apiUrl, "_blank");
    };

    const generateThumbnail = async (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result);
            };
            reader.readAsDataURL(file);
        });
    };

    return (
        <div>
            <Card style={{ padding: "16px", marginBottom: "16px" }}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <div variant="text" style={{ fontWeight: "500" }}>
                            Candidate Documents
                        </div>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "right" }}>
                        <Button variant="outlined" onClick={handleClick}>
                            Upload Files
                        </Button>
                        <input
                            type="file"
                            style={{ display: "none" }}
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            multiple
                        />
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            {menuItems.map((item, index) => (
                                <MenuItem key={index} onClick={() => handleMenuItemClick(item)}>
                                    {item}
                                </MenuItem>
                            ))}
                        </Menu>
                    </Grid>
                </Grid>
            </Card>
            <Grid container spacing={2}>
                {selectedFiles.map((fileData, index) => (
                    <Grid
                        item
                        key={index}
                        xs={isMobile ? 12 : undefined}
                        sm={isTablet ? 6 : undefined}
                        md={isDesktopSmall ? 3 : undefined}
                        lg={isDesktopLarge ? 3 : undefined}
                        onClick={() => openFileInNewTab(fileData)}
                    >
                        <Card
                            style={{
                                padding: "12px",
                                height: "150px",
                                position: "relative",
                                cursor: "pointer",
                            }}
                        >
                            <div>
                                <span
                                    style={{
                                        textAlign: "left",
                                        backgroundColor: "ghostwhite",
                                        fontSize: "12px",
                                    }}
                                >
                                    {" "}
                                    {/* {fileData.attachment_name} */}
                                </span>
                            </div>
                            <div style={{ flex: 1 }}>
                                {getFileType(fileData?.name) === "image" ? (
                                    <img
                                        src={fileData.thumbnail}
                                        alt="Thumbnail"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                        }}
                                    />
                                ) : getFileType(fileData?.name) === "pdf" ? (
                                    <div style={{ height: "140px" }}>
                                        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                                            <Viewer
                                                fileUrl={url("candidate_attachment_file")(
                                                    fileData?.user_id,
                                                    fileData?.cand_id,
                                                    fileData?.name
                                                )}
                                                defaultScale={0.25}
                                            />
                                        </Worker>

                                    </div>
                                ) : (
                                    getFileTypeIcon(getFileType(fileData?.name), fileData.thumbnail)
                                )}

                            </div>
                            <Typography
                                variant="body1"
                                style={{
                                    fontSize: "13px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    position: "absolute",
                                    bottom: "0",
                                    left: "0",
                                    width: "100%",
                                    textAlign: "center",
                                    backgroundColor: "ghostwhite",
                                    padding: "4px",
                                    borderRadius: "0 0 8px 8px",
                                }}
                            >
                                <span
                                    style={{ fontSize: "13px", fontWeight: "500" }}
                                    title={fileData?.attachment_name}
                                >
                                    {fileData?.attachment_name}
                                </span>
                            </Typography>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
}

export default DocumentsView;
